import { AnyPage, CarDetailPage, GlobalProps } from '@tmh-website/shared/cms';
import { Color } from '@tmh-website/shared/colors';
import { DefaultLocalePrefix, LocalePrefix, LocaleToAudienceMap, PrefixToLocaleMap } from '@tmh-website/shared/const';

export function fourOhFourPageData(locale: LocalePrefix): Exclude<AnyPage, CarDetailPage> {
  return {
    id: 0,
    title: '',
    locale: PrefixToLocaleMap[locale] ?? PrefixToLocaleMap[DefaultLocalePrefix],
    localizations: [],
    content: [],
    slug: '',
    path: '',
    createdAt: '',
    updatedAt: '',
    /**
     * The 404 page needs to be compatible with all audiences, thus the page data has to include all of them.
     */
    audiences: LocaleToAudienceMap[locale],
    metaTitle: '',
    metaDescription: '',
    metaRobots: 'noindex, nofollow',
    isSearchable: false,
    headerTheme: Color.Neutral_0_White,
  };
}

export function fourOhFourGlobalData(): GlobalProps['global'] {
  return {
    navigation: [],
    navigationHighlights: [],
    menuQuickLinks: [],
    footerLinkGroups: [],
    footerLegalLinks: [],
    socialLinks: [],
    metaTitle: '',
    metaDescription: '',
    metaImage: {
      id: 0,
      url: '',
      alternativeText: '',
      type: 'image',
      width: 0,
      height: 0,
      ext: '',
      hash: '',
    },
    robots: '',
  };
}
